const BASE_MAP = {
    // 个人本地
    '127.0.0.1': 'http://150.109.149.180:8010',
    'localhost': 'http://150.109.149.180:8010',
    '192.168.1.28': 'http://150.109.149.180:8010',
    '192.168.30.252': 'http://150.109.149.180:8010',
    // 香港服务器
    'www.dadu.tw': 'https://www.dadu.tw'
}
// 本地/局域网访问（含 IP 变动的情况）统一走测试后端，其余走线上
const BASE_URL = BASE_MAP[window.location.hostname]
    || (/^(localhost|127\.|192\.168\.|10\.)/.test(window.location.hostname) ? 'http://150.109.149.180:8010' : 'https://www.dadu.tw')
// 评价token
const EVALUATION_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0eXBlIjoidmlldyIsImFwcElkIjoiYXBwX2Q4Y2Q4MzBiZWFlODIyMDgiLCJuYW1lIjoiZGFkdXNob3AiLCJkb21haW5zIjpbInd3dy5kYWR1LnR3Iiwid3d3LmRhZGUudHciLCIqLmRhZHUudHciLCIqLmRhZGUudHciLCIxOTIuMTY4LjEuMjgiXSwiaWF0IjoxNzc1NDYxMTk1fQ.vc8tUJDWJvT4lFSseEUbJx9t2NNMqHiQwjvuv3RflFA'
// 评价服务开关（comment.dadu.tw 暂时不可用，恢复后改为 true）
const EVALUATION_ENABLED = false
export default {
    BASE_URL,
    EVALUATION_TOKEN,
    EVALUATION_ENABLED
}



//////////////////
// WEBPACK FOOTER
// ./static/config/global.js
// module id = 6053
// module chunks = 38